export default {
    designations: [],
    designation:{},
    demoUsers: [],
    agencyUsers: [],
    users: [],
};